<template>
  <!-- 寮生呼び出し -->
  <v-form>
    <v-container>
      <v-card outlined>
        <v-row>
          <v-card-title> 寮生呼び出し 
            <v-col>
              <ryou-blue-btn :label="isShow ? '全選択解除':'全選択'" :handlerClick="onAllClick"></ryou-blue-btn>
            </v-col>
          </v-card-title>
          
        </v-row>
      </v-card>
      </v-container>
    <v-container>
        
          <v-card class="pa-0 mt-0 mb-0 mr-0 ml-0">
            <v-row v-for="(floorItems,fIndex) in floorList" :key="fIndex" class="florRow">
              <v-col cols="14">
                <v-row>
                  <v-col v-for="(floorVal, index) in floorItems.called_info" :key="index" class="flex-grow-0 pt-0 pb-0 pr-0">

                    <v-card v-bind:color="floorItems.floor%2==0 ?'blue lighten-3':'blue lighten-5'" width="165">
                      <v-card-text class="text-light pa-0">
                        <v-checkbox
                                    v-model="floorVal.is_checked"
                                    :disabled="floorVal.is_disabled"
                                    :class="floorVal.call_flg === 1 ? 'orange lighten-3' : ''"
                                    @change="onClick(floorVal)"
                                    hide-details="false"
                                    :label="floorVal.user_name!==null ?floorVal.room_id +':'+ floorVal.user_name:floorVal.room_id + ':'">
                        </v-checkbox>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
    </v-container>
  </v-form>
</template>

<script>

  import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";

  export default {
    components: {
      RyouBlueBtn,
    },
    mounted() {
        },
    data() {
        return {
            floorList: [],
            buildingId: "",
            selectBuildingId: "",
            isShow: false,//全選択・全解除判定用フラグ
            url: {
                get: "/dormitoryUser/callListGet",
                update: "/dormitoryUser/callUserUpdate",
            },
        }
    },

    watch: {

    },

    created() {
      this.initData()
    },

    methods: {
      initData() {//eslint-disable-line
          // 画面表示で必要な処理の呼び出し。
          // 建物IDを取得（管理人の場合、自身の管理対象となっている建物IDのみを取得（他の処理であるため、個別実装不要。
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      this.getRequest("/masterRoom/buildingGet", params, this.$store.getters.getUserToken).then((data) => {
        if (data.success) {
          this.selectBuildingId = data.result[0].building_id//物件ID
          this.getCallUserList(this.selectBuildingId)
        }
      });
        setTimeout(() => { }, 100);
    },

      getCallUserList() {
        let param = {
          buildingId: this.selectBuildingId
        };
        this.getRequest(this.url.get, param, this.$store.getters.getUserToken).then(data => {

          if (data.success) {
            //TODO
            this.floorList = data.result
          }
        });
        setTimeout(() => { }, 100);
      },

      // チェックボックスクリック時のイベント
      onClick(floorVal) {
            // 部屋に人がいない場合はリクエストしない
            if (floorVal.user_id == null) {
                if (floorVal.call_room_id == null) {
                    floorVal.call_room_id = floorVal.room_id
                } else {
                    floorVal.call_room_id = null
                }
              // チェックボックスOFF（checkedValuesに直接変更）
              this.$set(floorVal, 'is_checked', false);
              this.$toast.open({
                    message: "寮生がいない部屋のため、呼び出ししません。",
                    type: "warning"
              });
              return
            }
        if (floorVal.is_checked == false) {
          floorVal.call_flg = 0
        } else {
          floorVal.call_flg = 1
        }

        let params = {
          updUserId: this.$store.getters.getUserId,//更新者
          buildingId: floorVal.building_id,//物件ID
          roomId: floorVal.room_id,//部屋番号
          userId: floorVal.user_id,//更新対象者
          callFlg: floorVal.call_flg,//呼び出しフラグ
            };

        this.postRequest(this.url.update, params, this.$store.getters.getUserToken).then(data => {
          if (data.success) {
            this.clear()
            this.getCallUserList()
          }
        });
        setTimeout(() => { }, 100)
      },

      onAllClick() {
        let params = {}
        switch (this.isShow) {
          case false://全選択の処理 callFlgに9をセット
            this.isShow = true
            params["updUserId"] = this.$store.getters.getUserId
            params["buildingId"] = this.selectBuildingId
            params["callFlg"] = 9
            break
          case true://全解除の処理 callFlgに8をセット
            params["updUserId"] = this.$store.getters.getUserId
            params["buildingId"] = this.selectBuildingId
            params["callFlg"] = 8
            this.isShow = false
            break
        }
        this.postRequest(this.url.update, params, this.$store.getters.getUserToken).then(data => {
          if (data.success) {
            this.clear()
            this.getCallUserList()
          }
        });
        setTimeout(() => { }, 100)
      },

      clear() {
        this.floorList = []

      },

    },
  };
</script>

<style scoped>
  .florRow {
    justify-content: left;
  }


</style>